'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _messages = require('conversations-core/reducers/messages');

var _messages2 = _interopRequireDefault(_messages);

var _salesUsers = require('conversations-core/reducers/salesUsers');

var _salesUsers2 = _interopRequireDefault(_salesUsers);

var _salesTeams = require('conversations-core/reducers/salesTeams');

var _salesTeams2 = _interopRequireDefault(_salesTeams);

var _smartLists = require('conversations-core/reducers/smartLists');

var _smartLists2 = _interopRequireDefault(_smartLists);

var _conversations = require('conversations-core/reducers/conversations');

var _conversations2 = _interopRequireDefault(_conversations);

var _meetingsLinks = require('conversations-core/reducers/meetingsLinks');

var _meetingsLinks2 = _interopRequireDefault(_meetingsLinks);

var _visitors = require('conversations-core/reducers/visitors');

var _visitors2 = _interopRequireDefault(_visitors);

var _snippets = require('conversations-core/reducers/snippets');

var _snippets2 = _interopRequireDefault(_snippets);

var _responders = require('conversations-core/reducers/responders');

var _responders2 = _interopRequireDefault(_responders);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Map)();
  var action = arguments[1];

  var newState = state.merge({
    messages: (0, _messages2.default)(state.get('messages'), action),
    meetingsLinks: (0, _meetingsLinks2.default)(state.get('meetingsLinks'), action),
    salesUsers: (0, _salesUsers2.default)(state.get('salesUsers'), action),
    salesTeams: (0, _salesTeams2.default)(state.get('salesTeams'), action),
    smartLists: (0, _smartLists2.default)(state.get('smartLists'), action),
    conversations: (0, _conversations2.default)(state.get('conversations'), action),
    visitors: (0, _visitors2.default)(state.get('visitors'), action),
    snippets: (0, _snippets2.default)(state.get('snippets'), action),
    responders: (0, _responders2.default)(state.get('responders'), action)
  });

  return newState;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/reducers/entities.js
// module id = 509
// module chunks = 0